import { Task } from './task.model'
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { pathOr } from 'ramda'

export interface State extends EntityState<Task> {
  isLoaded: boolean
  isUpdating: boolean
}

export const adapter: EntityAdapter<Task> = createEntityAdapter<Task>({
  sortComparer: (a: Task, b: Task) =>
    pathOr('', ['name'], a)
      .toString()
      .localeCompare(pathOr('', ['name'], b), undefined, { numeric: true, sensitivity: 'base' }),
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isUpdating: false,
})
